import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import Input from './input'
import Icon from './icon'
import TopTooltip from './topTooltip'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import createLinkToImmutable from '_/utils/createLinkToImmutable'
import { Map } from 'immutable'

/**
 * Bottom navigation component
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class EmailRecordModal extends React.Component {
  static propTypes = {
    recordId: React.PropTypes.string.isRequired
  }

  static contextTypes = {
    store: React.PropTypes.object
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      showModal: false,
      data: Map({
        emails: []
      }),
      link: createLinkToImmutable(this, 'data')
    }
  }

  showWindow () {
    this.setState({ showModal: true })
  }

  hideWindow () {
    this.setState({
      showModal: false,
      data: Map({
        emails: []
      }),
      link: createLinkToImmutable(this, 'data')
    })
  }

  async sendEmail (evt) {
    evt.preventDefault()

    const { recordId } = this.props
    const { store } = this.context
    const { data } = this.state

    try {
      await store.post(`/records/${recordId}/sendEmail`, data)
      this.hideWindow()
    } catch (er) {
      this.setState({
        errors: er.response.body.details
      })
    }
  }

  render() {
    const { data, link, showModal } = this.state

    return (
      <span>
        <TopTooltip key={0} content="Email record to a friend">
          <Button
            bsStyle="link"
            onClick={::this.showWindow}>
            <Icon name ="fa-envelope" />
          </Button>
        </TopTooltip>

        <Modal key={1} show={showModal} onHide={::this.hideWindow}>
          <Modal.Header closeButton>
            <h4 className="modal-title">Email this record</h4>
          </Modal.Header>

          <Modal.Body>
            <p>Send this private record out to non-members by including their email addresses below. The link will be valid for a week.</p>
            <Input
              autoFocus
              multi
              type="text-multi"
              valueLink={link('emails')}
              name="emails" />
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="submit"
              bsStyle="primary"
              disabled={!data.get('emails').size}
              onClick={::this.sendEmail}>
              Yes, email this record
            </Button>
          </Modal.Footer>
        </Modal>
      </span>
    )
  }
}

export default EmailRecordModal



// WEBPACK FOOTER //
// ./modules/shared/components/emailRecordModal.js